import { Component, HostListener, OnInit } from '@angular/core';
import { Router,Event, NavigationEnd} from '@angular/router';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { MatDialog, MatDialogConfig} from '@angular/material/dialog';
import { LoginDialogComponent } from 'src/app/shared/components/login-dialog/login-dialog.component';
import { GlobalSearchService } from 'src/app/shared/services/global-search.service';
declare var dataLayer;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  public isMobileDevice: boolean = false;
  public showScrollHeight = 1;
  public hideScrollHeight = 1;
  public showScroll: boolean;
  public isLoggedInUser: boolean;
  public isPayRouteActive: boolean = false;
  public globalSearchResultSize = 20;
  public autoSuggestionArry:any=[];
  userType: string;
  userId: any;
  tierType: any;
  constructor(public router: Router,
    private dialog: MatDialog,
    private commonFunction: CommonFunctions,
    private golbalSearchService:GlobalSearchService
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
          if(event.url.includes( '/pay' )){
            this.isPayRouteActive = true;
          }else{
            this.isPayRouteActive = false;
          }
      }
  });
  this.userType = this.commonFunction.getUserType();
  this.userId = this.commonFunction.getUserId();
  this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
     this.isMobileDevice = this.commonFunction.identifyDeviceType();
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if ((window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) > this.showScrollHeight) {
      this.showScroll = true;
    }
    else if (this.showScroll && (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop) < this.hideScrollHeight) {
      this.showScroll = false;
    }
  }
  public openPayPage() {
    this.isLoggedInUser = this.commonFunction.verifyLoggedInUser();
    if (this.isLoggedInUser == true) {
      this.router.navigate(['/pay']);
    } else {
      this.openLoginDialog();
    }
  }
  public openLoginDialog(): void {
    sessionStorage.setItem('module', 'pay');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      redirectTo:'/pay',
      showBarista: true,
      message: 'This is a heading space to include brand content'
    };
    dialogConfig.disableClose = true;
    dialogConfig.minWidth='45vw';
    dialogConfig.maxWidth='70vw';
    const dialogRef = this.dialog.open(LoginDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }
public getAutoSearchList(event:any,value:string){
  let reqParm=this.getGlobalSearchRequest(value);
  this.golbalSearchService.getAutoSuggestion(reqParm).subscribe((res)=>{
    this.autoSuggestionArry=res['response']
  });
}
public getGlobalSearchRequest(value){
  return [
    {
      name:"searchKey",
      value:value
    },{
      name:"size",
      value:this.globalSearchResultSize
    }
    ]
}
public searchKey(key){
  sessionStorage.removeItem('globalSearchkey')
  sessionStorage.setItem('globalSearchkey', key);
  this.searchClickGA(key);
  this.router.navigate(['/search'])
}
searchClickGA(searchKey){
  dataLayer.push({
    'event': 'search_click',
      'userID':this.userId,
      'user_type':this.userType,
      'tier':this.tierType,
     ' search_text':searchKey
  })
}
profileClickGA(){
  dataLayer.push({
    'event': 'profile_click',
      'userID':this.userId ,
      'user_type':this.userType,
      'tier':this.tierType
  })
}
topNavigationGA(navType){
  dataLayer.push({
    'event':'top_navigation_click',
      'userID':this.userId,
      'top_navigation_type':navType,
      'tier':this.tierType,
      'user_type':this.userType
  })
}
}
